import { Box } from "@mui/material";
import React, { useMemo, useRef } from "react";
import Chart from 'react-apexcharts';
import FormatToIntCurrency from "utils/FormatToIntCurrency";
import { useChartWidth } from "./useChartWidth";

const LineChart = ({ chartData = [], height = 280 }) => {
    const containerRef = useRef(null);
    const containerWidth = useChartWidth(containerRef);
    const plotHeight = Math.max(height - 8, 200);
    const plotWidth = containerWidth > 0 ? containerWidth : '100%';

    const series = useMemo(() => ([
        {
            name: 'Invested',
            data: chartData.map((obj) => ({
                x: new Date(obj.createdAt),
                y: obj.invested,
            })),
        },
        {
            name: 'Profit',
            data: chartData.map((obj) => ({
                x: new Date(obj.createdAt),
                y: (obj.worth - obj.invested),
            })),
        },
        {
            name: 'worth',
            data: chartData.map((obj) => ({
                x: new Date(obj.createdAt),
                y: obj.worth,
            })),
        },
    ]), [chartData]);

    const options = useMemo(() => ({
        chart: {
            type: 'area',
            foreColor: '#fff',
            toolbar: { show: false },
            zoom: { type: 'x', enabled: false },
            animations: { enabled: false },
        },
        legend: {
            show: true,
            position: 'top',
            horizontalAlign: 'right',
            labels: { colors: '#fff' },
        },
        dataLabels: { enabled: false },
        markers: { size: 0 },
        fill: { opacity: 1 },
        yaxis: {
            labels: {
                formatter: (val) => FormatToIntCurrency(val),
            },
        },
        xaxis: {
            type: 'datetime',
            labels: { datetimeUTC: false },
        },
        tooltip: {
            shared: false,
            y: {
                formatter: (val) => FormatToIntCurrency(val),
            },
        },
        grid: {
            padding: { top: 0, right: 8, bottom: 0, left: 8 },
        },
    }), []);

    return (
        <Box
            ref={containerRef}
            sx={{ width: '100%', height: plotHeight, minHeight: plotHeight, overflow: 'hidden' }}
        >
            <Chart
                height={plotHeight}
                width={plotWidth}
                id="chartContainer"
                series={series}
                options={options}
                type="area"
            />
        </Box>
    );
};

export default LineChart;
